import { render, staticRenderFns } from "./type83.vue?vue&type=template&id=ab079764&scoped=true"
import script from "./type83.vue?vue&type=script&lang=js"
export * from "./type83.vue?vue&type=script&lang=js"
import style0 from "./type83.vue?vue&type=style&index=0&id=ab079764&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!D:\\work\\dys\\duyisheng-admin-ui\\node_modules\\vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab079764",
  null
  
)

export default component.exports